import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  ASSIGN_REPORTS_TO_PARTNER_ACCOUNT,
  ASSIGN_REPORTS_TO_PARTNER_ACCOUNT_SUCCESS,
  ASSIGN_REPORTS_TO_PARTNER_ACCOUNT_FAILED,
} from '../../constants';

import { fetchAccountOverview } from '../../actions/account-actions';

import store from '../../store';

const assignReportsToPartnerAccount = (action$, state$) =>
  action$.pipe(
    ofType(ASSIGN_REPORTS_TO_PARTNER_ACCOUNT),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/partners/${action.clientId}?v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {
          store.dispatch(fetchAccountOverview());
          return {
            type: ASSIGN_REPORTS_TO_PARTNER_ACCOUNT_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: ASSIGN_REPORTS_TO_PARTNER_ACCOUNT_FAILED,
            error,
          })
        )
      )
    )
  );

export default assignReportsToPartnerAccount;
